<div class="popup_header">
    <strong class="popup_title">이미지보기</strong>
    <button type="button" class="popup_close" (click)="popupClose()"><span class="blind">팝업 닫기</span></button>
</div>
<div class="popup_content wAuto">
    <div *ngFor="let item of list" class="popup_fullImg">
        <img src="{{item}}" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'">
    </div>
</div>
